/** App status indicator */
export type AppStatus = 'online' | 'offline' | 'maintenance';

/** Definition of an app in the Vertex ecosystem */
export interface AppDefinition {
  id: string;
  name: string;
  description: string;
  icon: string;
  /** Optional dark-theme icon; falls back to `icon` when empty. */
  iconDark?: string;
  launchUrl: string;
  requiredRole: string;
  category: string;
  status: AppStatus;
  team?: string;
  /** Whether the app is hidden from the app store (visible only in admin) */
  hidden?: boolean;
}

/**
 * App catalog — all apps are now fetched dynamically from Keycloak clients.
 * Register apps via the Admin Panel > App Management.
 */
export const APP_CATALOG: AppDefinition[] = [];
